import {Injectable} from "@angular/core";
import {ClearingCrudComponent} from "../../../crystal-clear/support/clearing-crud/clearing-crud.component";
import {FieldRecord} from "../../../model/api/field-record";
import {Clearing} from "../../../model/clearing/clearing";
import {AccountDefinition} from "../../../model/customer/account-definition";
import {StringUtils} from "../../../utils/stringUtils";

@Injectable({
  providedIn: 'root'
})
export class SupportClearingDataLoadingService {

  openCloses: FieldRecord<any>[];
  clearingStates: FieldRecord<any>[];

  loadData(component: ClearingCrudComponent) {
    this.openCloses = Object.keys(AccountDefinition.OpenClose).map(key => new FieldRecord(key, StringUtils.humanize(key)));
    this.clearingStates = Object.keys(Clearing.ClearingState).map(key => new FieldRecord(key, StringUtils.humanize(key)));

    component.tracker.incrementTotal();
    component.tracker.incrementDone();

  }
}
